var ResultState;
(function (ResultState) {
    ResultState["ACCEPTED"] = "accepted";
    ResultState["REJECTED"] = "rejected";
})(ResultState || (ResultState = {}));
export class Result {
    constructor(resolver) {
        resolver((value) => {
            if (!this.state) {
                this.value = value;
                this.state = ResultState.ACCEPTED;
            }
        }, (value) => {
            if (!this.state) {
                this.value = value;
                this.state = ResultState.REJECTED;
            }
        });
        if (!this.state) {
            throw new Error(`Result must be resolved`);
        }
    }
    isSuccess() {
        return this.state === ResultState.ACCEPTED;
    }
    isRejected() {
        return this.state === ResultState.REJECTED;
    }
    map(transform) {
        if (this.isSuccess()) {
            return Result.accept(transform(this.value));
        }
        return this;
    }
    flatMap(transform) {
        if (this.isSuccess()) {
            return transform(this.value);
        }
        return this;
    }
    unwrap() {
        if (!this.isSuccess()) {
            throw this.value;
        }
        return this.value;
    }
    static accept(value) {
        return new Result((accept) => accept(value));
    }
    static reject(value) {
        return new Result((_, reject) => reject(value));
    }
}
//# sourceMappingURL=Result.js.map